<template>
    <div class="" :style="{minHeight: minHeight}">
        <!-- <b-modal 
            v-model="transitionModalShowing"
            centered
            hide-header
            hide-footer
            :size="activeTransition.modalSize"
            @hidden="handleTransitionModalHidden"
        > -->
        <div v-if="canLoad && canShow">
            <transition name="fade-faster" mode="out-in">
            <div v-if="activeTransition.loadingDetail" key="loadingTransDetail" class="w-100 d-flex align-items-center justify-content-center" :style="{minHeight: minHeight}">
                <busy-spinner class="w-100 h-100"></busy-spinner>
            </div>
            <div v-else-if="activeTransition.errorMsg" :key="activeTransition.errorMsg" class="">
                <b-alert variant="warning" show>
                    <!-- <h6 class="mb-3 text-center">Oops, there was a problem handling this action.</h6> -->
                    <h6 class="text-center">{{ activeTransition.errorMsg }}</h6>
                </b-alert>
                <div class="mt-3 text-right">
                    <!-- this is basically just like the 'cancel' button but for error conditions -->
                    <b-button
                        v-if="!hideCancel"
                        variant="primary"
                        @click="handleTransFormCancel"
                    >
                        Close
                    </b-button>
                </div>
            </div>
            <div v-else key="notLoadingTransDetail" class="">
                <h4 class="mb-4">{{ activeTransition.confirmTitle }}</h4>
                <p 
                    v-for="para in activeTransition.confirmDescription"
                    :key="para"
                >{{ para }}</p>
                <!-- these collapse if no content -->
                <h5>{{ activeTransition.title }}</h5>
                <p>{{ activeTransition.instructions }}</p>
                <div class="mt-3">
                    <FormulateForm
                        v-model="activeTransition.data"
                        :schema="activeTransition.schema"
                        @submit="handleTransFormSubmit"
                        #default="{ isLoading, hasErrors }"
                    >
                        <div class="mt-5 d-flex justify-content-end gap-3">
                            <!-- show this after save success?  or from parent? <b-badge variant="soft-success" class="special-text font-size-100">Saved</b-badge> -->
                            <FormulateInput
                                v-if="!hideCancel"
                                type="button"
                                label="Cancel"
                                :outer-class="['minimal']"
                                @click="handleTransFormCancel"
                                :disabled="isLoading || activeTransition.readOnly"
                            />
                            <!-- Modal header (and therefore close button) is hidden so we must always show this -->
                            <FormulateInput
                                type="submit"
                                name="submit"
                                :label="isLoading ? 'Loading...' : activeTransition.buttonLabel"
                                :disabled="isLoading || hasErrors || activeTransition.readOnly"
                            />
                        </div>
                    </FormulateForm>
                </div>
            </div>
            </transition>
        </div>
        <!-- </b-modal> -->
    </div>
</template>

<script>
import { errorHandling } from '@/js/custom-vue-mixins';
import cloneDeep from 'lodash/cloneDeep';

// NOTE: this should likely go inside a modal, but does not have to
// it should be completely destroyed when hidden so it doesn't hold state
// INTENDED TO WORK (ONLY) WITH INSTANCES OF FlowObject 

// EMITS: 'loading-start', 'loading-end', 'loading-error', 'transition-start', 'transition-success', 'transition-error', 'transition-end', 'cancel'

export default {
    name: 'FlowObjectTransitionForm',
    components: {},
    mixins: [errorHandling],
    props: {
        flowObject: { // must be an instance of FlowObject
            type: Object,
            required: true,
        },
        trigger: {  // the trigger name to start the transition
            type: String,
            required: true,
        },
        minHeight: {  // set a min height for the content, prevents jumping when loading
            type: String,
            default: '250px',
        },
        hideCancel: {  // if true, will not show the cancel button - makes sense for non-modal use
            type: Boolean,
            default: false,
        },
        // how to show the stuff?  call the startTransition method from parent component?  or have a :show="true" prop?
        // we will have an 'auto-start' prop, will check that in mounted(), then if true, call startTransition
        autoStart: {  // if true, will call startTransition() in mounted()
            type: Boolean,
            default: false,
        },
        noReloadOnSuccess: {  
            // if true, we do not call reload() on success, but otherwise we do
            // maybe parent wants to kill this component and do its own stuff (like if its in a modal) - set this to true
            // or maybe it will keep it showing... (like in a static place on a page) - set this to false
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            canShow: false,  // set to true when we have a transition to show
            activeTransition: {},  // will hold all the data for the current transition
        }
    },
    computed: {
        canLoad() {
            // put a watcher on the triggerName, when it changes, update a timestamp and use that combined thing as key for everything to show/hide
            return this.flowObject && this.trigger;
        }
    },
    created() {
        
    },
    mounted() {
        if (this.autoStart) {
            // if we have autoStart, call startTransition() to load the data
            this.start();
        }
    },
    beforeDestroy() {
        // reset the active transition on FlowObject when this component is destroyed, or else it will get 'stuck'
        console.log('FlowObjectTransitionForm beforeDestroy');
        this.resetActiveTransition();
    },
    methods: {
        ////////////// PUBLIC METHODS - call from parent //////////
        async start() {
            // this is the public method to start the transition
            // this will call the backend to get the transition detail, then show the modal
            return await this.startTransition(this.trigger);
        },
        ////////////////////////
        async reload() {
            // call this when we are successful and we want to reload the transition data / start again
            // the exact behavior depends on whether autoStart is true or not
            this.resetActiveTransition();  // reset the active transition so we can reload if needed
            console.log('FlowObjectTransitionForm reload called');
            if (this.autoStart) {
                // if autoStart is true, we just call start again
                await this.start();
            }
        },
        performEmit(eventName, extraPayload = {}) {
            // utility to emit events with consistent payload, and extra stuff if needed
            const activeTransition = cloneDeep(this.activeTransition);
            const payload = {
                event: eventName,
                trigger: activeTransition.trigger,
                activeTransition: activeTransition,
                ...extraPayload,
            }
            this.$emit(eventName, payload);
        },
        async startTransition(triggerName) {
            console.log('startTransition - trigger is:', triggerName);
            // const triggerName = transSpecObj.trigger;
            if (this.activeTransition?.trigger) {
                // if we're already in a transition, don't start another one
                const pendingMsg = 'Another action is currently pending. Try later.';
                console.error(pendingMsg);
                this.$toast.warning(pendingMsg);
                return;
            }
            this.resetActiveTransition();  // do this BEFORE setting the new stuff - also sets canShow=false, but we'll set true in a bit...
            this.activeTransition = {  // make sure all these keys are set, even if they're empty -- must be reactive
                trigger: triggerName,
                loadingDetail: true,  // loading for the detail call
                loadingCall: false,  // loading for the POST call itself
                modalSize: 'sm',  // set this based on the size of the content... if we have a form, use 'md' - if just a confirmation, use 'sm'
                errorMsg: '',
                detail: {},  // the full transition detail object from backend -- will get from API and extract data part out
                confirmTitle: '',  // will replace with data from detail call
                confirmDescription: [],  // will replace with data from detail call (list of strings)
                buttonLabel: '',  // will replace with data from detail call
                title: '',  // will replace with data from detail call
                instructions: '',  // will replace with data from detail call
                schema: [],  // will replace with data from detail call
                data: {},  // will replace with data from detail call
                readOnly: false,  // set this to true if we don't want to allow actual submission of the form, set in backend -- only makes sense for non-modal forms... special cases... might want to make this smarter later
            }
            this.performEmit('loading-start');
            this.canShow = true;  // show the modal just before we make API call (but after we set loadingDetail = true) to make it seems more snappy
            let transDetail;
            try {
                const resp = await this.flowObject.fetchTransitionDetail(triggerName);  // returns the response.data not the response itself... might want to change that?
                transDetail = resp.data;
                // console.log('transition detail', transDetail);
            } catch (error) {
                console.error(`Got error trying to get transition detail for trigger name ${triggerName} - error.response:`, error.response);
                let errorMsg = 'There was a problem fetching the action details';  // default... change below based on error type
                if (error.response?.status == 409) {
                    // console.error(`Got 409 error while trying to fetch submission transition detail for trigger name ${triggerName}`);
                    // console.error(error);
                    errorMsg = error.response?.data || 'This action is no longer available';
                } else {
                    this.apiErrorHandler(error);
                }
                const errorDetail = {
                    errorMsg: errorMsg,
                    loadingDetail: false,
                };
                // console.log('Error detail to merge into activeTransition:', errorDetail);
                this.activeTransition = Object.assign({}, this.activeTransition, errorDetail);  // starting with {} so its a fresh object, otherwise Vue reactivity can miss it!
                // console.log('activeTransition after error:', this.activeTransition);
                this.performEmit('loading-error', {error: error});
                return;  // done... don't need to continue
            }
            if (transDetail && !this.activeTransition.errorMsg) {
                console.log('in startTransition we got the detail', transDetail);
                // OR SHOULD WE JUST REFER TO THE FLOW OBJECT FOR THIS?  WE KEEP activeTransition IN THE FLOW OBJECT ALSO...
                const formSchema = transDetail.form?.form?.items ? cloneDeep(transDetail.form.form.items) : [];
                const backendDetail = {
                    modalSize: formSchema && formSchema.length ? 'md' : 'sm',  // if we have a form, use 'md' - if just a confirmation, use 'sm'
                    detail: transDetail,  // the full detail object - still need some stuff from it
                    confirmTitle: transDetail.confirm_title || '',
                    confirmDescription: transDetail.confirm_description || [],
                    buttonLabel: transDetail.confirm_button_text || transDetail.label || 'Submit',  // default to Submit if not set?
                    title: transDetail.form?.form?.title || '',
                    instructions: transDetail.form?.form?.instructions || '',
                    schema: formSchema,  // form.form has {title, instructions, items}
                    data: transDetail.form?.data ? cloneDeep(transDetail.form.data) : {},
                    loadingDetail: false,  // we are done, so we can turn off loading also
                    readOnly: transDetail.form?.form?.read_only || false,  // set this to true if we don't want to allow actual submission of the form, set in backend -- only makes sense for non-modal forms... special cases... might want to make this smarter later
                };
                this.activeTransition = Object.assign({}, this.activeTransition, backendDetail);  // starting with {} so its a fresh object, otherwise Vue reactivity can miss it!
            }
            this.performEmit('loading-end');
        },
        /* async handleTransitionModalHidden() {
            this.resetActiveTransition();
        }, */
        resetActiveTransition() {
            // utility to reset everything related to submission transition
            this.activeTransition = {};  // reset all the things
            this.flowObject.clearActiveTransition();
            this.canShow = false;  // probably already closed, but anyways
        },
        handleTransFormCancel() {
            this.canShow = false;  // close it, then the @hidden event will reset things
            this.performEmit('cancel');  // emit an event so parent can do something if needed
            // should we reset/restart?  TBD... depends on autoStart and other stuff
        },
        async handleTransFormSubmit(submitData) {
            // make sure this is async since we call it from @submit event of formulate form, which expects an async function to show loading, make sure uploads complete, etc.
            console.log('submitData from submission transition', submitData);
            // DO ANY PREP WORK ON DATA HERE, then just call our other method, which uses flowObject to call the transition
            await this.callActiveTransition(submitData);
        },
        async callActiveTransition(submitData) {
            console.log('HELLO FROM callActiveTransition - submitData is:', submitData);
            this.performEmit('transition-start');
            this.$set(this.activeTransition, 'loadingCall', true);  // set this directly so it's reactive
            let respData = {};
            let wasSuccess = false;
            try {
                const resp = await this.flowObject.callTransition(this.activeTransition.trigger, submitData, false);  // no refresh in here... we'll do it ourselves when done
                respData = resp?.data || {};
                this.performEmit('transition-success', {responseData: cloneDeep(respData)});
                wasSuccess = true;
            } catch (err) {
                console.error('error calling transition in CompItemManage', err); 
                this.performEmit('transition-error', {error: err});  // payload?
                wasSuccess = false;
            }
            this.$set(this.activeTransition, 'loadingCall', false);
            // PUT THESE THINGS (toast, etc.) IN PARENT COMPONENT
            // if (respData.success && respData.message) {
            //     const successToastMsg = respData.message;
            //     this.$toast.success(successToastMsg);
            // }
            this.performEmit('transition-end');

            if (wasSuccess && !this.noReloadOnSuccess) {
                this.reload();  // reload the transition data, which will reset the activeTransition and show the new data
                // we only do this if we were successful, so we can show the new data -- otherwise we might have errors to show
            }
        },
    },
}
</script>

<style lang="scss" scoped>
</style>